import { render, staticRenderFns } from "./CompanyConfigManagement.vue?vue&type=template&id=8ea48006&scoped=true"
import script from "./CompanyConfigManagement.vue?vue&type=script&lang=js"
export * from "./CompanyConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./CompanyConfigManagement.vue?vue&type=style&index=0&id=8ea48006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea48006",
  null
  
)

export default component.exports